import { configureStore } from "@reduxjs/toolkit";
import SupplierSlice from "./Slices/SupplierSlice";
import CustomerSlice from "./Slices/CustomerSlice";
import RawMaterialSlice from "./Slices/RawMaterialSlice";
import ProductSlice from "./Slices/ProductSlice";
import StockStatsSlice from "./Slices/StockStatsSlice";
import SupplierInvoiceSlice from "./Slices/SupplierInvoiceSlice";
import CustomerInvoiceSlice from "./Slices/CustomerInvoiceSlice";
import CustomerReturnInvoiceSlice from "./Slices/CustomerReturnInvoiceSlice";
import CustomerPaymentSlice from "./Slices/CustomerPaymentSlice";
import CustomerLedgerSlice from "./Slices/CustomerLedgerSlice";
import SupplierLedgerSlice from "./Slices/SupplierLedgerSlice";
import ExpenseSlice from "./Slices/ExpenseSlice";
import ExpenseTypeSlice from "./Slices/ExpenseTypeSlice";
import LoanSlice from "./Slices/LoanSlice";
import LabourSlice from "./Slices/LabourSlice";
import RMStockStatsSlice from "./Slices/RMStockStatsSlice";
import DashboardSlice from "./Slices/DashboardSlice";
import InvestorSlice from "./Slices/InvestorSlice";
import InvestmentsSlice from "./Slices/InvestmentsSlice";
import CategorySlice from "./Slices/CategorySlice";
import SubCategorySlice from "./Slices/SubCategorySlice";
import CompanyPaymentSlice from "./Slices/CompanyPaymentSlice";
import AccountSlice from "./Slices/AccountSlice";
import CashBookSlice from "./Slices/CashBookSlice";
import CashAdjustmentSlice from "./Slices/CashAdjustmentSlice";
import CustomerItemSummarySlice from "./Slices/CustomerItemSummarySlice";
import ItemLedgerSlice from "./Slices/ItemLedgerSlice";
import BranchesSlice from "./Slices/BranchesSlice";
import CompanyItemSummarySlice from "./Slices/CompanyItemSummarySlice";
import ReportSlice from "./Slices/ReportSlice";
import ItemStatsSlice from "./Slices/ItemStatsSlice";

export const store = configureStore({
  reducer: {
    DashboardData: DashboardSlice,
    DashboardData: DashboardSlice,
    Suppliers: SupplierSlice,
    Customers: CustomerSlice,
    RawMaterials: RawMaterialSlice,
    ItemsState: ProductSlice,
    StockStats: StockStatsSlice,
    SupplierInvoices: SupplierInvoiceSlice,
    CustomerInvoices: CustomerInvoiceSlice,
    CustomerReturnInvoices: CustomerReturnInvoiceSlice,
    CustomerPayments: CustomerPaymentSlice,
    CompanyPayments: CompanyPaymentSlice,
    CustomerLedgers: CustomerLedgerSlice,
    // CustomerItemLedgers: CustomerItemLedgerSlice,
    ItemLedgerStates: ItemLedgerSlice,
    CustomerItemLedgers: CustomerLedgerSlice,
    SupplierLedgers: SupplierLedgerSlice,
    Expenses: ExpenseSlice,
    ExpenseTypes: ExpenseTypeSlice,
    Loans: LoanSlice,
    Labours: LabourSlice,
    RMStockStats: RMStockStatsSlice,
    Investors: InvestorSlice,
    Investments: InvestmentsSlice,
    CategoriesState: CategorySlice,
    SubCategoriesState: SubCategorySlice,
    AccountState: AccountSlice,
    CashBookState: CashBookSlice,
    CashAdjustmentState: CashAdjustmentSlice,
    CustomerItemSummaryState: CustomerItemSummarySlice,
    Branches: BranchesSlice,
    CompanyItemSummaryState: CompanyItemSummarySlice,
    ReportState: ReportSlice,
    ItemStatState: ItemStatsSlice,
  },
});
